import { get_custom_list} from "./Indicators";
import {maplibre_str, geoserver} from "../Geoportal";

  
export function set_innitial_selected_datasets_longrange(data, layername,  
                                                      years_setter=null, selected_dates_setter=null,
                                                    setter_current=null, latest_dates_setter=null, dates_setter=null, key_current=null) {
    var latest_year = data?.latest_year;
    var start_year = data?.start_year;
    var latest_forecast_period_str = data?.latest_forecast_period_str;
    var years = get_custom_list(start_year, latest_year);
    if (years_setter !== null){
      years_setter(years);
    }
  
      selected_dates_setter({
        year: latest_year,
        period: latest_forecast_period_str,
      });
  
    var geosever_link = `${geoserver}${maplibre_str}${layername}&CQL_FILTER=year=${latest_year} AND forecast_period ='${latest_forecast_period_str}'`;


    if (key_current !== null){
       setter_current({[key_current]:geosever_link});
    }else {
        
        setter_current(geosever_link);
    }

    dates_setter({
      year:years,
      period:data[latest_year]?.forecast_periods_str
,
    })
    
   
  }